<template>
    <div id="app">
        <el-container v-if="!isAdminRoute">
            <el-header>
                <div class="logo">
                    <img :src="getImagePath('toplogo.png')" alt/>
                </div>
                <el-menu
                    :default-active="defaultActive"
                    class="el-menu-demo"
                    mode="horizontal"
                    @select="handleSelect"
                    :router="router"
                >
                    <el-menu-item index="/">{{ $t('menu.home') }}</el-menu-item>
                    <el-menu-item index="/news">{{ $t('menu.news') }}</el-menu-item>
                    <el-menu-item index="/cpzx">{{ $t('menu.product') }}</el-menu-item>
                    <!--          <el-menu-item index="/product">产品中心</el-menu-item>-->
                    <el-menu-item index="/jjfa">{{ $t('menu.solution') }}</el-menu-item>
                    <el-menu-item index="/case">{{ $t('menu.cases') }}</el-menu-item>
                    <el-menu-item index="/goin">{{ $t('menu.about') }}</el-menu-item>
                    <el-menu-item index="/shfw">{{ $t('menu.service') }}</el-menu-item>
                    <el-menu-item index="/download">{{ $t('menu.download') }}</el-menu-item>
                </el-menu>
                <div class="lang-switch">
                    <el-button
                        size="small"
                        :type="$i18n.locale === 'zh' ? 'primary' : ''"
                        @click="switchLang('zh')"
                    >
                        中文
                    </el-button>
                    <el-button
                        size="small"
                        :type="$i18n.locale === 'en' ? 'primary' : ''"
                        @click="switchLang('en')"
                    >
                        EN
                    </el-button>
                </div>
            </el-header>
            <el-main>
                <router-view/>
            </el-main>
            <div class="footer">
                <div class="footer-content">
                    <ul class="content-nav">
                        <li>
                            <p>{{ $t('footer.news') }}</p>
                            <span>{{ $t('footer.companyNews') }}</span>
                            <span>{{ $t('footer.industryNews') }}</span>
                        </li>
                        <li>
                            <p>{{ $t('footer.products') }}</p>
                            <span>{{ $t('footer.recorder') }}</span>
                            <span>{{ $t('footer.workstation') }}</span>
                            <span>{{ $t('footer.system') }}</span>
                            <span>{{ $t('footer.cabinet') }}</span>
                        </li>
                        <li>
                            <p>{{ $t('footer.solutions') }}</p>
                            <span>{{ $t('footer.industrySolution') }}</span>
                            <span>{{ $t('footer.cabinetSolution') }}</span>
                        </li>
                        <li>
                            <p>{{ $t('footer.about') }}</p>
                            <span>{{ $t('footer.history') }}</span>
                            <span>{{ $t('footer.culture') }}</span>
                            <span>{{ $t('footer.honors') }}</span>
                            <span>{{ $t('footer.partners') }}</span>
                        </li>
                        <li>
                            <p>{{ $t('footer.service') }}</p>
                            <span>{{ $t('footer.afterSales') }}</span>
                            <span>{{ $t('footer.policy') }}</span>
                        </li>
                        <li>
                            <p>{{ $t('footer.contact') }}</p>
                            <span>{{ $t('footer.email') }}</span>
                            <span>{{ $t('footer.phone') }}</span>
                            <span>{{ $t('footer.address') }}</span>
                        </li>
                    </ul>
                    <img :src="getImagePath('ercode.jpg')" alt/>
                </div>
                <div class="copyright">
                    <span>{{ $t('footer.copyright') }}</span>
                </div>
            </div>
        </el-container>
        <router-view v-else/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            router: true,
            defaultActive: "/",
            isShow: false
        };
    },
    computed: {
        isAdminRoute() {
            return this.$route.path.startsWith('/admin');
        }
    },
    methods: {
        handleSelect(key) {
            this.isShow = this.defaultActive != key;
            window.console.log(this.isShow);
        },
        switchLang(lang) {
            this.$i18n.locale = lang;
            localStorage.setItem('lang', lang);
            window.location.reload();
        }
    }
};
</script>



<style lang="scss">
* {
    padding: 0;
    margin: 0;
}

html,
body {
    height: 100%;
}

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

.el-header {
    //position: fixed;
    //z-index: 1024;
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 1240px;
    margin: 0 auto;
    //background-color: #fff;

    .logo {
        width: 280px;
        padding: 10px;

        img {
            width: 100%;
            line-height: 60px;
        }
    }

    .lang-switch {
        display: flex;
        align-items: center;
        gap: 5px;
    }
}

.el-main {
    padding: 0 !important;
    //margin-top: 60px;
}

.footer {
    width: 100%;
    height: 235px;
    overflow: hidden;
    background-color: #14679f;

    &-content {
        width: 1340px;
        margin: 0 auto;
        padding-top: 20px;
        display: flex;
        justify-content: space-between;

        .content-nav {
            display: flex;
            justify-content: space-around;

            li {
                display: flex;
                flex-direction: column;
                padding: 0 20px;
                //justify-content: center;
                align-items: flex-start;

                p {
                    font-size: 20px;
                    color: #d4edff;
                    padding: 10px 0;
                }

                span {
                    color: #f7f7f7;
                    font-weight: 300;
                    padding: 5px 0;
                }
            }
        }

        img {
            width: 170px;
            height: 170px;
            padding: 10px;
        }
    }

    .copyright {
        //height: 30px;
        //background: #125688;
        font-size: 0.75em;
        color: #e1e1e1;
        line-height: 1.5;
        text-align: center;

        span {
            color: #fff;
            //line-height: 30px;
            padding-bottom: 5px;
        }
    }
}
</style>
